var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ending",on:{"click":_vm.goUrl}},[(_vm.ending.img)?_c('div',{staticClass:"notice-img"},[_c('img',{attrs:{"src":_vm.ending.img}})]):_c('div',{staticClass:"notice"},[_vm._v("\n    活动已结束，点此跳转到主网站\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-138a2728","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/end.vue
// module id = null
// module chunks = 